import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import StartPage from '../components/StartPage.vue'
import Start from '../components/Start.vue'
import ForChild from '../components/ForChild.vue'
import SignUp from '../components/SignUp.vue'
import Courses from '../components/Courses.vue'
import Contacts from '../components/Contacts.vue'

import ForParents from '../components/ForParents.vue'
import ForSpecialist from "../components/ForSpeсialist.vue"


Vue.use(VueRouter)

const routes = [

 
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/forKids',
    name: 'ForChild',
    component: ForChild
  },
  {
    path: '/forParents',
    name: 'ForParents',
    component: ForParents
  },
  {
    path: '/forSpecialist',
    name: 'ForSpecialist',
    component: ForSpecialist
  },

  {
    path: '/startPage',
    name: 'StartPage',
    component: StartPage
  },
  {
    path: '/signUp',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/courses',
    name: 'Courses',
    component: Courses
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts
  },
  
 
]

const router = new VueRouter({
  routes
})

export default router
